import { render } from "./FlightPassengersView.vue?vue&type=template&id=76391416"
import script from "./FlightPassengersView.vue?vue&type=script&lang=js"
export * from "./FlightPassengersView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__